import { FC, Fragment } from 'react'
import { Box, Typography, useTheme } from '@mui/material'

import { Avatar, Tooltip, Spinner } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import { getFullImageUrl } from 'utils'
import { useTranslation } from 'react-i18next'
import { usePerson } from 'hooks'
export interface IPersonDetailsProps {
    size?: any
    person?: any
    loading?: boolean
    enabled?: boolean
}

export const PersonDetails: FC<IPersonDetailsProps> = (props) => {
    const { t } = useTranslation()
    const { size, person, enabled, loading } = props
    const theme = useTheme()
    return (
        <Box
            sx={{
                display: 'flex',
                marginBottom: '8px',
                marginTop: '8px',
                alignItems: 'center',
                wordBreak: 'break-word',
            }}
        >
            <Box
                sx={{
                    marginRight: '10px',
                    '& > div': {
                        height: '30px',
                        width: '30px',
                    },
                }}
            >
                <Avatar
                    size={size}
                    src={getFullImageUrl(person.imageThumbUrl)}
                />
            </Box>

            <Box>
                {person.friendlyName && (
                    <Typography
                        sx={{
                            fontSize: '14px',
                            color: theme?.palette?.common?.black,
                            lineHeight: 1.14,
                        }}
                    >
                        {person.friendlyName}
                    </Typography>
                )}

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: '2px',
                        marginLeft: '-4px',
                        '& > svg': {
                            margin: '0px 4px',
                            height: '14px',
                            width: '14px',
                        },
                    }}
                >
                    {person.email ? (
                        <a
                            href={`mailto:${person.email}`}
                            aria-label={`${t('Common_Email')} ${person.friendlyName || person.email}`}
                        >
                            <Tooltip
                                title={`mailto:${person.email}`}
                                disableInteractive={false}
                            >
                                <div>
                                    <Icon name="EmailRound" aria-hidden="true" />
                                </div>
                            </Tooltip>
                        </a>
                    ) : (
                        <Tooltip
                            title={`${
                                loading ? t('Loading') : t('No_Email_Tooltip')
                            }`}
                            style={{ cursor: 'pointer' }}
                        >
                            <div>
                                {!enabled || loading ? (
                                    <Icon name="EmailRound" />
                                ) : (
                                    <Icon
                                        name="EmailRound"
                                        style={{
                                            color: 'B4B4B4',
                                            cursor: 'default',
                                        }}
                                    />
                                )}
                            </div>
                        </Tooltip>
                    )}
                    {person.telephone ? (
                        <a
                            href={`tel:${person.telephone}`}
                            aria-label={`${t('Common_Phone')} ${person.friendlyName || person.telephone}`}
                        >
                            <Tooltip
                                title={person.telephone}
                                style={{ marginLeft: '5px' }}
                                disableInteractive={false}
                            >
                                <div>
                                    <Icon name="PhoneRound" aria-hidden="true" />
                                </div>
                            </Tooltip>
                        </a>
                    ) : (
                        <Tooltip
                            title={`${
                                loading ? t('Loading') : t('No_Phone_Tooltip')
                            }`}
                            style={{ marginLeft: '5px', cursor: 'pointer' }}
                        >
                            <div>
                                {!enabled || loading ? (
                                    <Icon name="PhoneRound" />
                                ) : (
                                    <Icon
                                        name="PhoneRound"
                                        style={{
                                            color: 'B4B4B4',
                                            cursor: 'default',
                                        }}
                                    />
                                )}
                            </div>
                        </Tooltip>
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export const Person = (props: any) => {
    const { data: person, isInitialLoading } = usePerson(props.personId, true)
    if (isInitialLoading) {
        return <Spinner />
    }
    if (person) {
        return (
            <div>
                <PersonDetails
                    size="medium"
                    person={{
                        imageThumbUrl: person.imageThumbUrl,
                        friendlyName: person.friendlyName,
                        email: person && person.login,
                        telephone: person && person.telephone,
                    }}
                />
            </div>
        )
    }

    return <Fragment>-</Fragment>
}
